import { render, staticRenderFns } from "./SimplePopover.vue?vue&type=template&id=3a8ee410&scoped=true&"
import script from "./SimplePopover.vue?vue&type=script&lang=js&"
export * from "./SimplePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ee410",
  null
  
)

export default component.exports